var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Avatar as CoreAvatar } from 'wix-ui-core/dist/es/src/components/avatar';
import { st, classes } from './Avatar.base.st.css';
import { AnonymousIcon } from './AnonymousIcon';
/** This is a Base component that should only be used internally. */
var AvatarBase = /** @class */ (function (_super) {
    __extends(AvatarBase, _super);
    function AvatarBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AvatarBase.prototype.render = function () {
        var _a = this.props, size = _a.size, src = _a.src, name = _a.name, onLoad = _a.onLoad, className = _a.className;
        return (React.createElement(CoreAvatar, { className: st(classes.root, className), imgProps: src ? { src: src, onLoad: onLoad } : undefined, placeholder: React.createElement(AnonymousIcon, { height: size, width: size }), name: name && name.split(' ')[0], "data-hook": this.props['data-hook'] }));
    };
    AvatarBase.displayName = 'AvatarBase';
    AvatarBase.defaultProps = {
        size: 36,
    };
    return AvatarBase;
}(React.Component));
export { AvatarBase };
//# sourceMappingURL=Avatar.base.js.map